import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DebounceDirective } from './debounce.directive';

@NgModule({
  imports: [CommonModule],
  exports: [DebounceDirective],
  declarations: [DebounceDirective],
})
export class DirectivesModule {}
